var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 265.08 92.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e8e4970c-843f-40a2-86cf-19980a00915a{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a39fc564-02a7-47b2-9f9a-0b0f6ef75e5e",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e8e4970c-843f-40a2-86cf-19980a00915a",
    d: "M256.45,50.1,201.18,81.35a3.62,3.62,0,0,1-3.68-.06L158.56,57.83a3.73,3.73,0,0,0-1.81-.53L85.59,55.79a3.74,3.74,0,0,1-1.78-.51L8.64,10.86"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.95da603e.svg";
export { ForwardRef as ReactComponent };